import { AnyAction } from 'redux';

import slice from '../reducer/slice';

const operation = (): AnyAction => slice.actions.resetUserCurrentLocation();

export default operation;
